import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { ObservationHandle as s } from "./ObservationHandle.js";

var e = /*#__PURE__*/function () {
  function e() {
    _classCallCheck(this, e);

    this._observers = [];
  }

  _createClass(e, [{
    key: "observe",
    value: function observe(_e) {
      return this._observers.includes(_e) || this._observers.push(_e), new s(this._observers, _e);
    }
  }, {
    key: "notify",
    value: function notify() {
      var s = this._observers.slice();

      for (var _e3 = 0; _e3 < s.length; ++_e3) {
        var r = s[_e3];
        r.onInvalidated(), r.onCommitted();
      }
    }
  }]);

  return e;
}();

export { e as SimpleObservable };